import * as React from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/hooks/useAuth";
import { OverviewCards } from "./OverviewCards";
import { QuickActions } from "./QuickActions";
import { Separator } from "@/components/ui/separator";

/**
 * DashboardContent - Main dashboard page content
 *
 * Features:
 * - Heading with personalized greeting
 * - Overview metrics grid
 * - Quick action buttons
 * - i18n: text resolved via useTranslation('dashboard')
 */
export function DashboardContent() {
  const { user } = useAuth();
  const { t } = useTranslation("dashboard");

  const getFirstName = () => {
    if (user?.user_metadata?.full_name) {
      return user.user_metadata.full_name.split(" ")[0];
    }
    return user?.email?.split("@")[0] || "there";
  };

  return (
    <div className="space-y-8">
      {/* Header section */}
      <div className="space-y-2">
        <h1 className="text-2xl font-semibold tracking-tight text-foreground">
          {t("pages.dashboard.title")}
        </h1>
        <p className="text-base text-muted-foreground md:text-lg">
          Hello, <span className="text-foreground">{getFirstName()}</span>!{" "}
          {t("pages.dashboard.welcomeMessage")}
        </p>
      </div>

      <Separator />

      {/* Overview metrics cards */}
      <section className="space-y-4">
        <h2 className="text-xs font-medium tracking-widest text-muted-foreground uppercase">
          {t("overview.title")}
        </h2>
        <OverviewCards />
      </section>

      {/* Quick actions */}
      <section>
        <QuickActions />
      </section>
    </div>
  );
}

export default DashboardContent;
